var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m21.268,3.561l-2.535-2.535c-.661-.661-1.54-1.025-2.475-1.025h-4.757c-2.31,0-4.197,1.756-4.449,4h-.551c-2.481,0-4.5,2.019-4.5,4.5v11c0,2.481,2.019,4.5,4.5,4.5h7c2.481,0,4.5-2.019,4.5-4.5v-.551c2.244-.252,4-2.139,4-4.449V5.329c0-.668-.26-1.296-.732-1.768Zm-.707.707c.204.204.339.458.4.732h-2.461c-.827,0-1.5-.673-1.5-1.5V1.124c.381.119.735.318,1.025.608l2.535,2.535Zm-7.061,18.732h-7c-1.93,0-3.5-1.57-3.5-3.5v-11c0-1.93,1.57-3.5,3.5-3.5h.5v9.5c0,2.481,2.019,4.5,4.5,4.5h5.5v.5c0,1.93-1.57,3.5-3.5,3.5Zm4-5h-6c-1.93,0-3.5-1.57-3.5-3.5V4.5c0-1.93,1.57-3.5,3.5-3.5h4.5v2.5c0,1.378,1.122,2.5,2.5,2.5h2.5v8.5c0,1.93-1.57,3.5-3.5,3.5Zm.5-7.5c0,.276-.224.5-.5.5h-2.5v2.5c0,.276-.224.5-.5.5s-.5-.224-.5-.5v-2.5h-2.5c-.276,0-.5-.224-.5-.5s.224-.5.5-.5h2.5v-2.5c0-.276.224-.5.5-.5s.5.224.5.5v2.5h2.5c.276,0,.5.224.5.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/copyIcon.e3a2a225c441d9612dae92ec77669483.svg";
export { ForwardRef as ReactComponent };